import { SVGProps } from 'react';

const BookmarkCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m9 10 2 2 4-4m4 13-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"
    />
  </svg>
);
export default BookmarkCheck;
